import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { constructArtificialLinkNode, getDynamicLink } from "../../../utils/links";
import { getProductCartQty } from "../productList/utils";
import { addToCart } from "../../../redux/actions/cartActions";
import { addToWishlist } from "../../../redux/actions/wishlistActions";
import { addToCompare } from "../../../redux/actions/compareActions";
import ProductVariationChooser from "./ProductVariationChooser";
import Rating from "../productList/sub-components/ProductRating";
import LinkWrapper from "../linkWrapper/LinkWrapper";
import { decodeText } from "../../../utils/richText";

const ProductDescriptionInfoSlider = ({
    product,
    discountedPrice,
    currency,
    finalDiscountedPrice,
    finalProductPrice,
    cartItems,
    wishlistItem,
    compareItem,
    addToCart,
    addToWishlist,
    addToCompare,
}) => {
    const [selectedProductColor, setSelectedProductColor] = useState("");
    const [selectedProductSize, setSelectedProductSize] = useState("");
    const [productStock, setProductStock] = useState(0);
    const [quantityCount, setQuantityCount] = useState(1);

    const productCartQty = getProductCartQty(cartItems, product, selectedProductColor, selectedProductSize);

    useEffect(() => {
        const defaultVariation = product && product.variation && product.variation["0"];

        // Products without variations sell on their top-level stock (the products service
        // guarantees one — demo storefront, nothing is ever out of stock).
        if (!defaultVariation) {
            setProductStock((product && product.stock) || 0);
            return;
        }

        const defaultSize = defaultVariation.size["@nodes"] ? defaultVariation.size[defaultVariation.size["@nodes"][0]] : null;

        setSelectedProductColor(defaultVariation.color);
        setSelectedProductSize(defaultSize ? defaultSize.name : "");
        setProductStock(defaultSize ? defaultSize.stock : product.stock || 0);
    }, [product]);

    return (
        <div className="product-details-content ml-70">
            <h2>{decodeText(product.displayName)}</h2>
            <div className="product-details-price">
                {discountedPrice !== null ? (
                    <Fragment>
                        <span>{currency.currencySymbol + finalDiscountedPrice}</span>{" "}
                        <span className="old">{currency.currencySymbol + finalProductPrice}</span>
                    </Fragment>
                ) : (
                    <span>{currency.currencySymbol + finalProductPrice} </span>
                )}
            </div>
            {product.rating && product.rating > 0 ? (
                <div className="pro-details-rating-wrap">
                    <div className="pro-details-rating me-0">
                        <Rating ratingValue={product.rating} />
                    </div>
                </div>
            ) : (
                ""
            )}
            <div className="pro-details-list">
                <p>{decodeText(product.shortDescription)}</p>
            </div>

            {product.variation && (
                <ProductVariationChooser
                    variation={product.variation}
                    selectedProductColor={selectedProductColor}
                    selectedProductSize={selectedProductSize}
                    setSelectedProductColor={setSelectedProductColor}
                    setSelectedProductSize={setSelectedProductSize}
                    setProductStock={setProductStock}
                    setQuantityCount={setQuantityCount}
                />
            )}

            {product.affiliateLink ? (
                <div className="pro-details-quality">
                    <div className="pro-details-cart btn-hover ms-0">
                        <a href={product.affiliateLink} rel="noopener noreferrer" target="_blank">
                            Buy Now
                        </a>
                    </div>
                </div>
            ) : (
                <div className="pro-details-quality">
                    <div className="cart-plus-minus">
                        <button onClick={() => setQuantityCount(quantityCount > 1 ? quantityCount - 1 : 1)} className="dec qtybutton">
                            -
                        </button>
                        <input className="cart-plus-minus-box" type="text" value={quantityCount} readOnly />
                        <button
                            onClick={() =>
                                setQuantityCount(quantityCount < productStock - productCartQty ? quantityCount + 1 : quantityCount)
                            }
                            className="inc qtybutton"
                        >
                            +
                        </button>
                    </div>
                    <div className="pro-details-cart btn-hover">
                        {productStock && productStock > 0 ? (
                            <button
                                onClick={() => addToCart(product, quantityCount, selectedProductColor, selectedProductSize)}
                                disabled={productCartQty > 0}
                                title={productCartQty > 0 ? "Added to cart" : "Add to cart"}
                            >
                                {productCartQty > 0 ? "Added" : "Add To Cart"}
                            </button>
                        ) : (
                            <button disabled>Out of Stock</button>
                        )}
                    </div>
                    <div className="pro-details-wishlist">
                        <button
                            className={wishlistItem !== undefined ? "active" : ""}
                            disabled={wishlistItem !== undefined}
                            title={wishlistItem !== undefined ? "Added to wishlist" : "Add to wishlist"}
                            onClick={() => addToWishlist(product)}
                        >
                            <i className="pe-7s-like" />
                        </button>
                    </div>
                    <div className="pro-details-compare">
                        <button
                            className={compareItem !== undefined ? "active" : ""}
                            disabled={compareItem !== undefined}
                            title={compareItem !== undefined ? "Added to compare" : "Add to compare"}
                            onClick={() => addToCompare(product)}
                        >
                            <i className="pe-7s-shuffle" />
                        </button>
                    </div>
                </div>
            )}
            {product.category && product.category.length > 0 ? (
                <div className="pro-details-meta">
                    <span>Categories :</span>
                    <ul>
                        {product.category.map((single) => {
                            return (
                                <li key={single["@id"]}>
                                    <LinkWrapper
                                        linkNode={constructArtificialLinkNode({
                                            value: getDynamicLink("PRODUCT_OVERVIEW", single["@name"]),
                                        })}
                                    >
                                        {single.name}
                                    </LinkWrapper>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            ) : (
                ""
            )}

            <div className="pro-details-social">
                <ul>
                    <li>
                        <a href="//facebook.com">
                            <i className="fa fa-facebook" />
                        </a>
                    </li>
                    <li>
                        <a href="//dribbble.com">
                            <i className="fa fa-dribbble" />
                        </a>
                    </li>
                    <li>
                        <a href="//pinterest.com">
                            <i className="fa fa-pinterest-p" />
                        </a>
                    </li>
                    <li>
                        <a href="//twitter.com">
                            <i className="fa fa-twitter" />
                        </a>
                    </li>
                    <li>
                        <a href="//linkedin.com">
                            <i className="fa fa-linkedin" />
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    );
};

ProductDescriptionInfoSlider.propTypes = {
    addToCart: PropTypes.func,
    addToCompare: PropTypes.func,
    addToWishlist: PropTypes.func,
    cartItems: PropTypes.array,
    compareItem: PropTypes.object,
    currency: PropTypes.object,
    discountedPrice: PropTypes.number,
    finalDiscountedPrice: PropTypes.number,
    finalProductPrice: PropTypes.number,
    product: PropTypes.object,
    wishlistItem: PropTypes.object,
};

const mapDispatchToProps = (dispatch) => {
    return {
        addToCart: (item, quantityCount, selectedProductColor, selectedProductSize) => {
            dispatch(addToCart(item, quantityCount, selectedProductColor, selectedProductSize));
        },
        addToWishlist: (item) => {
            dispatch(addToWishlist(item));
        },
        addToCompare: (item) => {
            dispatch(addToCompare(item));
        },
    };
};

export default connect(null, mapDispatchToProps)(ProductDescriptionInfoSlider);
